import React, { memo } from "react";
import styled from "styled-components";
import { Modal } from "antd";
import icon_cancel_black from "assets/icon_cancel_black.svg";
import { CloseOutlined } from "@ant-design/icons";

const ModalContentV2 = memo(
  ({
    className,
    modalIsOpen,
    onCancel,
    onConfirm,
    isShowBtnCancel,
    title,
    content,
    error,
    titleCancel,
    titleConfirm,
    loading,
    icon,
    isShowCancel,
    titleByCash,
    isShowbuttonCancel,
    conCancelModal,
    zIndex,
    maskClosable,
  }) => {
    return (
      <div className={className}>
        <Modal
          className={"custom-modal-rating"}
          open={modalIsOpen}
          footer={null}
          centered
          closable={false}
          zIndex={zIndex}
          maskClosable={maskClosable}
        >
          {isShowbuttonCancel && (
            <CloseOutlined
              className={"btnCloseModal"}
              onClick={conCancelModal}
              style={{
                color: "#000",
                backgroundColor: "#FFF",
                top: "-10px",
                right: "-10px",
                position: "absolute",
                fontSize: 16,
                borderRadius: 100,
                padding: 6,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.5)",
                zIndex: 2,
              }}
            />
          )}
          <div>
            {isShowCancel && (
              <div
                onClick={() => {
                  onCancel();
                }}
                className=" absolute right-0 top-0 mr-2 mt-2"
              >
                <img
                  src={icon_cancel_black}
                  className="img-menu-logo w-16 mt-5"
                  alt="warning"
                />
              </div>
            )}
            {icon && (
              <div className="flex justify-center items-center mt-4 pt-4">
                {icon}
              </div>
            )}
            <div className="text-center font-700 fs-16 ml-4 mr-4 pt-5">
              {title}
            </div>
            {titleByCash !== "" && (
              <div className="text-center font-700 fs-16 ml-4 mr-4">
                {titleByCash}
              </div>
            )}
            {content !== "" && (
              <div className="text-center mb-6 ml-4 mr-4 text-content whitespace-pre-wrap">
                {content}
              </div>
            )}
            {error !== "" && (
              <div className="text-center mb-6 ml-4 mr-4 text-content">
                {error}
              </div>
            )}
            <div
              className={
                isShowBtnCancel
                  ? "flex justify-between mt-8 items-center mb-2"
                  : "flex justify-center mt-8 items-center mb-2"
              }
            >
              {isShowBtnCancel ? (
                <div
                  onClick={onCancel}
                  className="btn_skip w-1/2 font-500 py-3 mx-2 fs-14 mb-5 ml-4"
                >
                  {titleCancel || ""}
                </div>
              ) : null}
              <div
                onClick={onConfirm}
                className="btn_ok w-1/2 font-500 py-3 mx-2 fs-14 mb-5 mr-4"
              >
                {titleConfirm || ""}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
);

export default styled(ModalContentV2)`
  .text-content {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    font-family: "Manrope", sans-serif;
  }
`;
